import { Space, SpaceProps } from '../space/Space';
import React from 'react';
import { TileTheme, useCurrentTheme } from '../themes';

type TileWrapperProps = Omit<SpaceProps, 'size'> & {
  height?: number;
  width?: number;
  /** Volitelný nadpis zobrazený nad tiles. */
  title?: string | React.ReactNode;
};

/**
 * Komponenta pro obalení více Tile komponent
 */
export const TileWrapper: React.FC<TileWrapperProps> = ({
  children,
  wrap = true,
  width,
  height,
  title,
  ...props
}) => {
  const theme = useCurrentTheme();

  const size: TileTheme | undefined = React.useMemo(() => {
    if (!width && !height) return undefined;
    width = width || 1;
    height = height || 1;
    const calculatedHeight =
      height * theme.tile.height + (height - 1) * theme.spacers[2];
    const calculatedWidth =
      width * theme.tile.width + (width - 1) * theme.spacers[2];

    return { height: calculatedHeight, width: calculatedWidth };
  }, [width, height]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }} {...props}>
      {title}
      <Space
        style={size ? { width: size?.width, height: size?.height } : {}}
        wrap={wrap}
        {...props}
        size={'2'}
      >
        {children}
      </Space>
    </div>
  );
};
